import React from 'react'
import aboutuskoffeehouse from "../images/about us _koffee.jpeg";
import Navbar from '../inc/Navbar';
import {Link} from "react-router-dom";
import birthday from "../images/birthday.jpeg"
import birthdayparty from "../images/birth day party.jpeg";
import birthdayevent from "../images/krishnagar family restaurant.jpeg"
function Birthday() {
  return (
    <div>
        <Navbar/>
          <br/>
        <br/>
        <br/>
        <br/>
          <div className='koffee'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Birthday Party Event <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

               <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
 <h1 className='mb-2 justify'>Birthday <b style={{color:"#3D2219"}}> Event</b></h1>
 <h3 style={{color:"#7a2204"}}><b>Celebrate Your Birthday with Us</b></h3>
 <p>Looking for the perfect place to celebrate a birthday in Krishnagar? Koffee House offers a cozy venue, tasty food, and customized arrangements for your special day. Enjoy a stress-free birthday celebration with great service and a warm ambiance.</p>
    <p className="card-text justify">Make your birthday extra special at Koffee House. Great food, happy vibes, and perfect party arrangements—all in one place. Book now for a fun and memorable celebration!</p>
   
                </div>
                  <div className="col-md-6 mt-3">
  <img src={aboutuskoffeehouse} className="card-img-top" alt="aboutuskoffeehouse"/>

                </div>
                </div>
                </div>
                
            
            </div>
            <br/>

             <div className="album py-0">
                <div className="container">
               
                    <div className="row">

                        <div className="col-md-4 mt-2">
                            <img src={birthday} className="card-img-top" alt="birthday" />

                        </div>
                         <div className="col-md-4 mt-2">
                            <img src={birthdayparty} className="card-img-top" alt="birthday" />

                        </div>
                         <div className="col-md-4 mt-2">
                            <img src={birthdayevent} className="card-img-top" alt="birthday" />

                        </div>
                        </div>
                        </div>
                        </div>
                        <br/>
    </div>
  )
}

export default Birthday